export default class Model {
  constructor(makeMobxStore, _) {
    this._ = _;
    this.reset = makeMobxStore(this);
  }
  set = {
    clusterDoc: (clusterDoc = {}) => {
      this.clusterDoc = clusterDoc;
    },
    node: (node = {}) => {
      this.node = node;
    },
    readme: (readme = "") => {
      this.readme = readme;
    },
    json: (json = {}) => {
      this.json = json;
    },
    related: (related = []) => {
      this.related = related;
    },
    input: input => {
      this.input = input;
    },
    output: output => {
      this.output = output;
    },
    error: error => {
      this.error = error;
    },
    running: (running = false) => {
      this.running = running;
    }
  };
  getTier = meterSize =>
    ({
      micro: "free",
      xs: "free",
      sm: "paid",
      md: "custom",
      lg: "custom",
      xl: "custom",
      xxl: "custom",
      super: "custom"
    }[meterSize] || "custom");

  get tier() {
    return this.getTier(this.node.meterSize);
  }
  get freeTier() {
    return this.tier === "free";
  }
  get paidTier() {
    return this.tier === "paid";
  }
  get customTier() {
    return this.tier === "custom";
  }
  get notOnApiPlan() {
    return this._.user.planApi === undefined;
  }
  get onFreeApiPlan() {
    return this._.user.planApi === "models-api-free";
  }
  get allowed() {
    return this.notOnApiPlan || this.customTier
      ? false
      : this.freeTier || this.onFreeApiPlan === false;
  }
  get needsUpgrade() {
    return this.onFreeApiPlan && this.freeTier === false;
  }
}
